import React, { useEffect, useState, useRef, useCallback } from 'react';
import { MapProps } from '../../Handbooks.types';
import styled from 'styled-components';
import { Icon } from 'office-ui-fabric-react';
import mapController from 'hoc/mapController';
import ReactDOMServer from 'react-dom/server';
import wkx from 'wkx';
import {
  Circle,
  FeatureGroup,
  Map,
  Marker,
  Polyline,
  TileLayer,
  Polygon,
  GeoJSON,
} from 'react-leaflet';
import { LatLng, DivIcon } from 'leaflet';
import { mapSettings } from 'config/consts';
import { getRoutesRequest } from 'api/video/route';
import {
  IRoute,
  parseRoutes,
} from 'views/pages/Video/OnlineWatching/utils/parseRoutes';

const StyledModalBody = styled.div`
  width: 100vw;
  height: 100vw;
  position: relative;
  margin-top: 10px;
  .leaflet-container {
    width: 100%;
    height: 100%;
  }
`;

const BottomRightPanel = styled.div`
  width: 36px;
  height: 84px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 401;
  position: absolute;
  right: 32px;
  bottom: 36px;
`;

const MapButtonBG = styled.div`
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.9);
`;

const getPointCenter = (props: MapProps) => {
  const lat = props.data[props.field.composite.lat];
  const lon = props.data[props.field.composite.lon];

  return lat && lon ? new LatLng(lat, lon) : null;
};

const MarkerMapPoint = (
  disabled?: boolean,
  opacity: number = 1,
  text?: string
) =>
  new DivIcon({
    html: ReactDOMServer.renderToString(
      <svg
        height="28"
        width="28"
        viewBox="0 0 40 40"
        style={{
          transform: 'translateX(-50%) translateY(-50%)',
          left: '50%',
          top: '50%',
          position: 'absolute',
        }}
      >
        <circle
          fill={disabled ? '#808080' : '#56CCF2'}
          stroke="#0300B2"
          strokeWidth={2}
          r="10"
          cx="20"
          cy="20"
          style={{ opacity }}
        />
        {text && (
          <text x="0" y="0" text-anchor="middle" transform="translate(20)">
            <tspan
              x="0"
              text-anchor="middle"
              dy="24"
              style={{ fontSize: '14px' }}
            >
              {text}
            </tspan>
          </text>
        )}
      </svg>
    ),
  });

export const MapForm: React.FC<MapProps> = (props: MapProps) => {
  const [settings, setSettings] = useState<{
    center?: LatLng | undefined;
    zoom?: number | undefined;
  }>({ center: mapSettings.center, zoom: 16 });

  const [geom, setGeom] = useState(<></>);

  useEffect(() => {
    if (props.field.composite.type === 'point_coords') {
      const lat = props.data[props.field.composite.lat];
      const lon = props.data[props.field.composite.lon];
      if (lat && lon) {
        setGeom(
          <Marker
            draggable={false}
            position={new LatLng(lat, lon)}
            icon={MarkerMapPoint(false)}
            onadd={() =>
              setSettings({ center: new LatLng(lat, lon), zoom: 16 })
            }
          />
        );
      }
    } else if (props.field.composite.type === 'polygon') {
      const dt = props.data[props.field.name];
      if (dt) {
        const wkbBuffer = new Buffer(dt, 'hex');
        const geom = wkx.Geometry.parse(wkbBuffer);
        const json = geom.toGeoJSON() as any;
        setGeom(
          <GeoJSON
            data={json}
            onadd={(ev) => {
              const bounds = ev.target.getBounds();
              mapRef!.current?.leafletElement.fitBounds(bounds);
              // setSettings({
              //   center: bounds.getCenter(),
              //   zoom:
              // })
            }}
          />
        );
      }
    } else {
      if (props.field.composite.type === 'trip') {
        getRoutesRequest([props.data[props.field.composite.field]]).then(
          (val: any) => {
            if (val) {
              const rt = parseRoutes(val);
              console.log(rt);
              setGeom(
                <FeatureGroup
                  onadd={(ev: L.LeafletEvent) => {
                    const bounds = ev.target.getBounds();
                    mapRef!.current?.leafletElement.fitBounds(bounds);
                  }}
                >
                  {rt.routes.map((route, index) => (
                    <Polyline
                      positions={route.position}
                      key={`${route.id}-${index}`}
                    />
                  ))}
                  {rt.stops.map((st) => (
                    <Marker
                      icon={MarkerMapPoint(false)}
                      position={st.position}
                      key={st.id}
                    />
                  ))}
                </FeatureGroup>
              );
            }
          }
        );
        //console.log(props.data[props.field.composite.field]);
      }
    }
  }, []);

  const mapRef = useRef<Map>(null);

  //const center = props.params === 'point_coords' ? getPointCenter(props) : mapSettings.center;

  //const { centerMap } = useMapHelpers(mapRef);

  // useEffect(() => {
  //   const map = mapRef?.current?.leafletElement;
  //   map!.fitBounds(geomData.geom);
  // }, [mapRef]);

  // const pt = getPointCenter(props);

  return (
    <>
      <StyledModalBody>
        <BottomRightPanel>
          <MapButtonBG
            onClick={() => {
              setSettings({
                ...settings,
                zoom: settings.zoom! < 18 ? settings.zoom! + 1 : settings.zoom,
              });
              //handleChangeMapSettings({ zoom: mapSettings.zoom + 1 });
            }}
          >
            <Icon iconName="CalculatorAddition" />
          </MapButtonBG>
          <MapButtonBG
            onClick={() => {
              setSettings({
                ...settings,
                zoom: settings.zoom! > 1 ? settings.zoom! - 1 : settings.zoom,
              });
            }}
          >
            <Icon iconName="CalculatorSubtract" />
          </MapButtonBG>
        </BottomRightPanel>
        <Map
          ref={mapRef}
          zoomControl={false}
          center={settings.center}
          zoom={settings.zoom}
          style={{ zIndex: 1 }}
          onzoomend={(event: L.LeafletEvent) => {
            setSettings({
              zoom: event.target.getZoom(),
              center: event.target.getCenter(),
            });
          }}
          ondragend={(event: L.DragEndEvent) => {
            //this.handleGetBounds(event);
          }}
          minZoom={2}
          maxZoom={18}
          // ref={this.mapRef}
          // onClick={this.onMapClick}
        >
          <TileLayer url={process.env.REACT_APP_MAP_TILES as string} />
          {geom}
        </Map>
      </StyledModalBody>
    </>
  );
};
